import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import { Row, Col, DatePicker, Select, Table, Button, Spin, Modal, Popover } from 'antd'
import moment from "moment"
import { app } from "../../app"
import api from "../../api"
import utils from "../../utils"
import config from "../../config"
import BigDataFilter from "../../components/BigDataFilter2"

const Option = Select.Option

class WorkReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataList: [],
            typeList: [],
            filter_type: '',
            filter_time: '',
            share_time: moment().subtract(1, 'days').unix(),
            filter_mark: '全国',
            filter_area_type: 'country',
            detail_modal: false,
            build_modal: false,
            iframe_loading: false,
            detailData: {},
            now_date: undefined
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.handleTypeSource()
        this.handleDataSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 获取报表详情数据
     * @param id
     * @param service_subject
     * @returns {Promise<*>}
     */
    handleDetailData = async (id) => {
        await this.setData({ detail_loading: true })
        let params = {
            id,
            request: 'reports',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.ReportsDetails, params)
        if (flag === 1) {
            let { principal, object_volunteer, object_volunteer_rear, is_domestic } = data
            if (is_domestic === '1') {
                data.area = [data.province, data.city, data.region].join(' ')
            }
            data.principal = (principal ? principal.map(p => p.vname) : []).join('、')
            let ov_vname = [], ovr_vname = []
            for (let i = 0; i < (object_volunteer || []).length; i++) {
                ov_vname.push(object_volunteer[i].vname)
            }
            for (let j = 0; j < (object_volunteer_rear || []).length; j++) {
                ovr_vname.push(object_volunteer_rear[j].vname)
            }
            data.object_volunteer = ov_vname.join('、')
            data.object_volunteer_rear = ovr_vname.join('、')
        } else {
            data = {}
            app.alert(msg, "error")
        }
        await this.setData({ detailData: data, detail_loading: false })
    }

    /**
     * 详情数据
     * @returns {Promise<void>}
     */
    handleDataSource = async () => {
        await this.setData({ data_loading: true })
        let { filter_type, filter_time, filter_mark, filter_area_type } = this.state, params = {
            type: filter_type || '0',
            time: filter_time,
            mark: filter_mark,
            area_type: filter_area_type,
        }
        let { flag, data, msg, time } = await app.post(api.ReportsReportsData, params)
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        let now_date = (time ? moment(time) : moment()).subtract(1, 'days')
        await this.setData({
            data_loading: false,
            dataList: utils.addArrayKey(data),
            now_date: now_date
        })
    }

    /**
     * 类型列表
     * @returns {Promise<void>}
     */
    handleTypeSource = async () => {
        await this.setData({ type_loading: true })
        let { flag, data, msg } = await app.post(api.ReportsReportsType)
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        await this.setData({ type_loading: false, typeList: data })

    }

    /**
     * 类型筛选
     * @param date
     * @returns {Promise<void>}
     */
    handleTypeFilter = async (filter_type) => {
        await this.setData({ filter_type })
        await this.handleDataSource()
    }

    /**
     * 时间筛选
     * @param date
     * @returns {Promise<void>}
     */
    handleDateFilter = async (date) => {
        await this.setData({ filter_time: date.format('YYYY-MM-DD'), share_time: date.unix() })
        await this.handleDataSource()
    }

    /**
     * 打开详情对话框
     */
    handleOpenDetailModal = async (id) => {
        await this.setData({ detail_modal: true })
        await this.handleDetailData(id)
    }

    /**
     * 关闭详情对话框
     */
    handleCloseDetailModal = () => {
        this.setData({ detail_modal: false })
    }

    /**
     * 关闭生成报表对话框
     */
    handleCloseBuildModal = () => {
        this.setData({ build_modal: false, iframe_loading: false })
    }

    /**
     * 打开生成报表对话框
     */
    handleOpenBuildModal = () => {
        this.setData({ build_modal: true, iframe_loading: true })
    }

    /**
     * 筛选变更
     * @param filter
     */
    handleFilterChange = async (filter) => {
        // console.log(filter)
        let filter_area_type = ''
        switch (filter.type) {
            case 1:
                filter_area_type = 'country'
                break
            case 2:
                filter_area_type = 'province'
                break
            case 3:
                filter_area_type = 'team'
                break
        }
        await this.setData({ filter_area_type, filter_mark: filter.mark })
        await this.handleDataSource()
    }

    render() {
        let { data_loading, dataList, typeList, type_loading, detail_modal, detailData, detail_loading, now_date, share_time, build_modal, iframe_loading } = this.state,
            columns = [
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: 'xh',
                    width: '10%',
                    render(x, d, i) {
                        return i + 1
                    }
                },
                {
                    title: '省份',
                    dataIndex: 'province',
                    key: 'province',
                    width: '10%'
                },
                {
                    title: '队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '15%'
                },
                {
                    title: '服务项目名称',
                    dataIndex: 'title',
                    key: 'title',
                    width: '35%',
                    render(title) {
                        return (<span style={{ textAlign: 'left' }}>{title}</span>)
                    }
                },
                {
                    title: '服务类型',
                    dataIndex: 'type_name',
                    key: 'type_name',
                    width: '10%'
                },
                {
                    title: '任务进程',
                    dataIndex: 'whether_succeed',
                    key: 'whether_succeed',
                    width: '10%',
                    render(ws) {
                        switch (ws) {
                            case '11':
                                return '已完成'
                            case '12':
                                return '未完成'
                            default:
                                return '-'
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '10%',
                    render: (id) => {
                        return <Button type="primary" size="small"
                            onClick={() => this.handleOpenDetailModal(id)}>查看详情</Button>
                    }
                },
            ]
        const filedRows = (key, label, value) => {
            return (
                <Row key={key} style={{ marginBottom: 14 }}>
                    <Col span={6} style={{ textAlign: 'right' }}>{label}:</Col>
                    <Col span={14} offset={1}>{value || '-'}</Col>
                </Row>
            )
        }
        return (
            <div className="sign-team page">
                <div className="page-title">
                    工作简报
                    <span style={{ color: 'red', marginLeft: 30, fontSize: 16 }}>
                        注：存心救援工作简报，每天凌晨零点更新，默认显示昨天的工作简报。
                    </span>
                </div>
                <div className="page-content">
                    <Row className="posi-filter" type="flex" align="middle">
                        <span>
                            {
                                now_date ? (
                                    <span>
                                        <label>选择时间：</label>
                                        <DatePicker defaultValue={now_date} format="YYYY年MM月DD日" allowClear={false}
                                            onChange={this.handleDateFilter} />
                                    </span>
                                ) : null
                            }
                            <span style={{ margin: '0 10px' }}>
                                <label>服务类型：</label>
                                <Select defaultValue="0" style={{ width: 120 }} onChange={this.handleTypeFilter}
                                    notFoundContent={type_loading ? <Spin type="small" /> : null}>
                                    <Option value="0">全部</Option>
                                    {
                                        typeList.map(t => {
                                            return (
                                                <Option key={t.id} value={t.id}>{t.name}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </span>
                        </span>
                        <span style={{ display: 'inline-block' }}>
                            <BigDataFilter change={this.handleFilterChange} />
                        </span>
                        <Button type="primary" onClick={this.handleOpenBuildModal}>生成报表</Button>
                    </Row>
                    <Table columns={columns}
                        loading={data_loading}
                        locale={app.tbLocale(data_loading)}
                        dataSource={dataList}
                        scroll={{ y: 'calc(100vh - 266.5px)' }}
                        size="small"
                        pagination={false}
                        className="table-odd-even-row"
                        style={{ marginTop: 20 }}
                        footer={null} />
                </div>
                <Modal
                    visible={build_modal}
                    title="生成报表"
                    onCancel={this.handleCloseBuildModal}
                    footer={null}
                    width={400}
                    centered={true}
                    maskClosable={true}
                    bodyStyle={{ textAlign: 'center', padding: 0, paddingBottom: 10 }}
                    destroyOnClose={true}>
                    <div style={{ textAlign: 'right', padding: 10, borderBottom: '1px solid #ddd' }}>
                        <Popover placement="right"
                            content={<QRCode value={config.reportDoman + share_time} />}
                            title="手机扫码分享" overlayStyle={{ textAlign: 'center', zIndex: 9999 }}>
                            <Button type="primary">手机扫码分享</Button>
                        </Popover>
                    </div>
                    <iframe src={config.reportDoman + share_time} frameBorder="0" width="360px" height="500px"
                        onLoad={() => {
                            this.setData({ iframe_loading: false })
                        }} />
                </Modal>
                <Modal
                    visible={detail_modal}
                    title="查看详情"
                    onCancel={this.handleCloseDetailModal}
                    footer={null}
                    width={1000}
                    maskClosable={true}
                    destroyOnClose={true}
                    bodyStyle={{
                        height: "calc(100vh - 100px)",
                        overflowY: "auto",
                        minHeight: 400,
                        position: 'relative'
                    }}
                    style={{ top: 20, paddingBottom: 20 }}>
                    {
                        detail_loading ? (<div style={{ textAlign: 'center' }}><Spin size="large" /></div>) : [
                            filedRows('1', '账号', detailData.account),
                            filedRows('2', '创建人', detailData.vname),
                            filedRows('3', '参与部门', detailData.department),
                            filedRows('4', '服务类型', detailData.type_name),
                            filedRows('5', '服务科目', detailData.subject_name),
                            filedRows('6', '服务项目名称', detailData.title),
                            filedRows('7', '相关人', detailData.relevant),
                            filedRows('8', '报案人', detailData.reporter),
                            filedRows('9', '报案人联系方式', detailData.reporter_contact),
                            filedRows('10', '服务对象', detailData.request_object),
                            filedRows('11', '服务对象联系方式', detailData.request_object_contact),
                            filedRows('12', '首次接触事务时间', detailData.event_time),
                            filedRows('13', '救援范围', detailData.is_domestic === '1' ? '国内' : '国外'),
                            filedRows('14', '省市区', detailData.area),
                            filedRows('15', '具体地址', detailData.address),
                            filedRows('16', '任务负责人/现场指挥', detailData.principal),
                            filedRows('17', '出队队伍', detailData.object_teamname),
                            filedRows('18', '现场出队队员', detailData.object_volunteer),
                            filedRows('19', '后台出队队员', detailData.object_volunteer_rear),
                            filedRows('20', '出队人数', detailData.action_people_number),
                            filedRows('21', '出队时间', detailData.action_time),
                            filedRows('22', '是否完成', detailData.whether_succeed === '11' ? '已完成' : '未完成'),
                            filedRows('23', '收队时间', detailData.recruit_time),
                            filedRows('24', '出队车辆数', detailData.action_car_number),
                            filedRows('25', '车牌号码', detailData.number_plate),
                            filedRows('26', '其他工具', detailData.other_tools),
                            filedRows('27', '事件进展', detailData.event_progress),
                            // filedRows('28', '服务时长/人', detailData.service_time),
                            filedRows('29', '受益人数', detailData.benefit_number),
                            filedRows('30', '任务总结', detailData.task_summary),
                            filedRows('31', '总结人', detailData.summary_person),
                            filedRows('32', '百度网盘链接', detailData.web_link),
                            filedRows('33', '事件图片', detailData.secret === '1' ? '保密任务' : (
                                <div>
                                    {(detailData.event_img || []).map((ei, index) => {
                                        return (
                                            <div key={index}>
                                                <img src={config.imgUrl + ei} style={{
                                                    width: 'auto',
                                                    height: 'auto',
                                                    maxWidth: '100%'
                                                }} alt="" />
                                            </div>
                                        )
                                    })}
                                </div>
                            )),
                        ]
                    }
                </Modal>
            </div>
        )
    }
}

export default WorkReport



// WEBPACK FOOTER //
// ./src/routes/bigData/WorkReport.jsx